import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "demo-deployment"
    }}>{`Demo Deployment`}</h1>
    <p>{`For Deployment we have provided two different approaches. `}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/vps-server-manual"
          }}>{`Manual Installation`}</a>{` guide.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/vps-server-automated"
          }}>{`Automated Script Installation`}</a>{` guide.`}</p>
      </li>
    </ul>
    <p>{`Please follow those link above based on your choice to know more about how to deploy the apps in virtual private server for inspecting the demo and features.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      